// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"777":"96f476c3","791":"38e28055"}[chunkId] + ".chunk.css";
};